import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import NProgress from 'nprogress';
import { useEffect } from 'react';

NProgress.configure({ showSpinner: false });

export const ShowProgressWhenPageChanges = () => {
  const router = useRouter();

  useEffect(() => {
    const start = () => NProgress.start();

    const originals = {
      push: router.push,
      replace: router.replace,
      back: router.back,
      forward: router.forward,
    };

    (['push', 'replace', 'back', 'forward'] as const).forEach((k) => {
      router[k] = (...args: Parameters<(typeof router)[typeof k]>) => {
        start();
        // eslint-disable-next-line
        // @ts-ignore
        originals[k](...args);
      };
    });

    return () => {
      // restore originals if the component unmounts
      // eslint-disable-next-line
      // @ts-ignore
      Object.entries(originals).forEach(([k, fn]) => (router[k] = fn));
    };
  }, [router]);

  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    NProgress.done();
  }, [pathname, searchParams]);

  return null;
};
